import { Input } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import Confirmation from './Confirmation';

function DeleteConfirmation(props) {
  const body = 'Are you sure? You can\'t undo this action afterwards.';
  const { header, isOpen, handleClose, handleDelete } = props;

  return (
    <Confirmation
      body={body}
      header={header}
      isOpen={isOpen}
      handleClose={handleClose}
      handleAction={handleDelete}
      actionButtonText='Delete'
      actionButtonBgColor='red.500'
      userInput={<Input></Input>}
    />
  );
}

DeleteConfirmation.propTypes = {
  header: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  handleDelete: PropTypes.func
};

export default DeleteConfirmation;
